import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    const targetId = event.params.target
    const modalElement = document.getElementById(targetId)
    if (modalElement) {
      const modal = Modal.getOrCreateInstance(modalElement)
      modal.show()
    }
  }
}
